import { LabelValueChoice, NameChoice } from '@/types/global';
import { ProfileStatusEnum } from '@/types/turn-enums';

export const CHOICES_MANUAL: LabelValueChoice[] = [
  { id: 'True', value: 'True', label: 'true' },
  { id: 'False', value: 'False', label: 'false' },
];

export const PROFILE_STATUS_CHOICES: NameChoice[] = [
  { id: ProfileStatusEnum.Emailed, name: ProfileStatusEnum.Emailed },
  { id: ProfileStatusEnum.Processing, name: ProfileStatusEnum.Processing },
  { id: ProfileStatusEnum.Review, name: ProfileStatusEnum.Review },
  { id: ProfileStatusEnum.ReviewIdentity, name: ProfileStatusEnum.ReviewIdentity },
  { id: ProfileStatusEnum.Consent, name: ProfileStatusEnum.Consent },
  { id: ProfileStatusEnum.Pending, name: ProfileStatusEnum.Pending },
  { id: ProfileStatusEnum.Approved, name: ProfileStatusEnum.Approved },
  { id: ProfileStatusEnum.ReviewQa, name: ProfileStatusEnum.ReviewQa },
  { id: ProfileStatusEnum.ReviewMvr, name: ProfileStatusEnum.ReviewMvr },
  { id: ProfileStatusEnum.ReviewSo, name: ProfileStatusEnum.ReviewSo },
  { id: ProfileStatusEnum.Rejected, name: ProfileStatusEnum.Rejected },
  { id: ProfileStatusEnum.PendingFirstNotice, name: ProfileStatusEnum.PendingFirstNotice },
  { id: ProfileStatusEnum.PendingSecondNotice, name: ProfileStatusEnum.PendingSecondNotice },
  { id: ProfileStatusEnum.Withdrawn, name: ProfileStatusEnum.Withdrawn },
  { id: ProfileStatusEnum.Initiated, name: ProfileStatusEnum.Initiated },
];

export const SSN_CHOICES: LabelValueChoice[] = [
  { id: 'true', value: '1', label: 'true' },
  { id: 'not-defined', value: '-1', label: 'not defined' },
  { id: 'false', value: '0', label: 'false' },
];
